<template>
    <b-breadcrumb :items="items" class="breadcrumbs"/>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data () {
    return {
      paths: {
        advertiser: 'Adop',
        'campaigns-manager': 'Campaigns Manager',
        domains: 'Domain lists',
        reports: 'Reports manager',
        bydate: 'by Date'
      },
      items: []
    }
  },
  mounted: function () {
    var upath = this.$route.fullPath
    upath.split('/').forEach(element => {
      if (element.length) {
        this.items.push({text: this.paths[element], class: 'breadcrumbs__item'})
      }
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/advertiser/plugins/breadcrumbs.vue